import React, { useEffect } from "react";
import { useAuth } from "zudoku/hooks";
import { ChevronsUpDown } from "zudoku/icons";
import { useTenantStore } from "../stores/tenantStore";
import useGetAPIDevelopers from "../APIs/useGetAPIDevelopers";

export default function TenantSwitcher() {
  const { isAuthenticated } = useAuth();
  const { currentTenant, hasHydrated, setCurrentTenant } = useTenantStore();
  const { data: developers, isLoading, isFetching, error } = useGetAPIDevelopers();

  useEffect(() => {
    if (isAuthenticated && hasHydrated && developers && developers.length > 0 && !currentTenant) {
      setCurrentTenant(developers[0].tenantCode.toLowerCase());
    }
  }, [developers, currentTenant, hasHydrated, isAuthenticated, setCurrentTenant]);

  if (!isAuthenticated) return null;

  if (!hasHydrated || isLoading || isFetching) {
    return (
      <div className="inline-block">
        <div className="flex items-center justify-center gap-2 w-full max-w-[450px]">
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (error || !developers || developers.length === 0) return null;

  return (
    <div className="inline-block">
      <div className="flex items-center justify-between gap-2 w-full max-w-[450px]">
        <div className="grid">
          <select
            aria-label="Select tenant"
            className="w-full row-start-1 col-start-1 text-foreground px-4 pe-6 appearance-none hover:bg-white hover:dark:bg-zinc-800/75 font-mono text-xs bg-border/50 dark:bg-border/70 py-1.5 max-w-[450px] truncate"
            value={currentTenant ?? ""}
            onChange={(e) => setCurrentTenant(e.target.value)}
          >
            {developers.map((developer) => (
              <option key={developer.id} value={developer.tenantCode.toLowerCase()}>
                {developer.tenantCode.toLowerCase()}
              </option>
            ))}
          </select>
          <div className="row-start-1 col-start-1 self-center justify-self-end relative end-2 pointer-events-none">
            <ChevronsUpDown size={14} />
          </div>
        </div>
      </div>
    </div>
  );
}
